import Api from './Api'
import config from './config'

import * as ls from 'local-storage'

export { config }
export default new Api(
	config.server.baseUrl,
	`Bearer ${(ls.get('userAuth') || {} as any).jwtToken}`,
)

export type CandidateStats = {
	lastScore: number,
	completed_num: number,
	ratings_num: number,
	happy_num: number,
	office_completed_num: number,
	office_very_happy_num: number,
	office_pleased_num: number,
	office_unhappy_num: number,
	office_cancelled: number,
	other_very_happy_num: number,
	other_pleased_num: number,
	other_unhappy_num: number,
	other_cancelled: number,
	is_blocked: number,
	is_favourite: number,
	hygienistScore: number,
	missedInterviewCount: number,
	status: number,
}
